import { WorkspaceMemberSelectField } from './WorkspaceMemberSelectField';

type AssigneeSelectProps = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  name?: string;
  label?: string;
  emptyLabel?: string;
  showPreview?: boolean;
  selectedLabel?: string;
  selectedAvatarSrc?: string;
};

export function AssigneeSelect({
  value,
  onChange,
  error,
  disabled,
  name = 'task-assignee',
  label = 'Assignee',
  emptyLabel,
  showPreview = true,
  selectedLabel,
  selectedAvatarSrc,
}: AssigneeSelectProps) {
  return (
    <WorkspaceMemberSelectField
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      emptyLabel={emptyLabel}
      showPreview={showPreview}
      selectedLabel={selectedLabel}
      selectedAvatarSrc={selectedAvatarSrc}
    />
  );
}
